<!--
~ Copyright (C) 2018 DV Bern AG, Switzerland
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as
~ published by the Free Software Foundation, either version 3 of the
~ License, or (at your option) any later version.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
-->

@if (allowedMap$ | async; as allowedGemeinden) {
    <div [ngClass]="{'form-group': true, 'ie-workaround': isIE()}">
        @if (showLabel) {
            <label
                [class.required]="needToShowRequired"
                [for]="inputId"
                translate
                >GEMEINDEN</label
            >
        }
        <mat-select
            class="form-control"
            [ngModel]="selected"
            [name]="inputId"
            [disabled]="disabled"
            [id]="inputId"
            [required]="required"
            [multiple]="true"
            [style.pointer-events]="disabled ? 'none' : 'auto'"
        >
            @for (item of allowedGemeinden | keyvalue: sortByName; track item) {
                <mat-option
                    (onSelectionChange)="onSelectionChange($event)"
                    [value]="item.key"
                >
                    {{ item.key.name }}
                </mat-option>
            }
        </mat-select>
        <dv-error-messages
            [inputId]="inputId"
            [errorObject]="form.controls[inputId]?.errors"
        >
        </dv-error-messages>
    </div>
}
